/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import { Center, useGLTF } from '@react-three/drei'
import type { ObjectMap } from '@react-three/fiber'
import { type JSX } from 'react'
import { MathUtils, type Mesh, type MeshStandardMaterial } from 'three'
import { type GLTF } from 'three-stdlib'

type GLTFResult = GLTF &
  ObjectMap & {
    nodes: {
      ['Headphones_Cube-Mesh']: Mesh
      ['Headphones_Cube-Mesh_1']: Mesh
      ['Headphones_Cube-Mesh_2']: Mesh
    }
    materials: {
      GrayTone1: MeshStandardMaterial
      GrayTone3: MeshStandardMaterial
      GrayTone2: MeshStandardMaterial
    }
  }

export function Headphones(props: JSX.IntrinsicElements['group']) {
  const { nodes, materials } = useGLTF('/models/headphones.glb') as GLTFResult
  return (
    <group {...props} dispose={null}>
      <Center position-y={0.35} rotation-z={MathUtils.degToRad(105)}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes['Headphones_Cube-Mesh'].geometry}
          material={materials.GrayTone1}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes['Headphones_Cube-Mesh_1'].geometry}
          material={materials.GrayTone3}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes['Headphones_Cube-Mesh_2'].geometry}
          material={materials.GrayTone2}
        />
      </Center>
    </group>
  )
}

useGLTF.preload('/models/headphones.glb')
